export default __webpack_public_path__ + "static/media/vision-section-07.5f0d00ff.png";